import dynaForms from '@elab/core/utils/dynaForms';
import { datePickerConstants } from '@elab/core/utils/constants';

import types, { DATE_FROM, DATE_TO, storeName } from './types';

export const initialState = () => ({
    records: [],
    pageNumber: 0,
    data: {
        dateFrom: {
            dateFormat: datePickerConstants.DEFAULT_FORMAT,
            label: '[DE] Delivery Date',
            name: DATE_FROM,
            readOnly: false,
            type: 'DATE',
            value: null,
            focused: false,
            touched: false,
        },
        dateTo: {
            dateFormat: datePickerConstants.DEFAULT_FORMAT,
            label: '[DE] Delivery Date',
            name: DATE_TO,
            readOnly: false,
            type: 'DATE',
            value: null,
            focused: false,
            touched: false,
        },
    },
});
const dynaFormReduce = dynaForms.createReducer(storeName);

const reducers = (state = initialState(), action) => {
    state = dynaFormReduce(state, action);
    const { type, payload } = action;

    switch (type) {
        case types.UPDATE_LOYALTY_CARD_HISTORY_LIST: {
            return {
                ...state,
                records: [...state.records, ...payload.entries],
                hasMoreEntries: payload.hasMoreEntries,
                pageNumber: state.pageNumber,
            };
        }
        case types.SET_PAGE_SIZE: {
            return {
                ...state,
                pageSize: payload.pageSize,
                records: [],
                hasMoreEntries: false,
                pageNumber: 0,
            };
        }
        case types.RESET_RECORDS: {
            return {
                ...state,
                records: [],
                hasMoreEntries: false,
                pageNumber: 0,
            };
        }
        case types.RESET_DATA: {
            return {
                ...state,
                data: {
                    ...state.data,
                    dateFrom: {
                        ...state.data.dateFrom,
                        value: null,
                        touched: false,
                    },
                    dateTo: {
                        ...state.data.dateTo,
                        value: null,
                        touched: false,
                    },
                },
                records: [],
                hasMoreEntries: false,
                pageNumber: 0,
            };
        }
        case types.SHOW_MORE: {
            return {
                ...state,
                pageNumber: state.pageNumber + 1,
            };
        }
        default:
            return state;
    }
};

export default reducers;
